import { useState } from 'react'
import React from 'react'
import axios from 'axios'
import { Table, Tag, Tooltip } from 'antd'


export default function Btc() {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  React.useEffect(() => {
    const fetchData = async () => {
      const result = await axios(`/zhihu`)
      setLoading(false)
      setData(result.data)
    }
    fetchData()
    setInterval(() => {
      fetchData()
    }, 60 * 60 * 1000);
  }, [])
  const columns = [
    {
      title: '日期',
      dataIndex: 'out_order_time',
    },
    {
      title: '商品',
      dataIndex: 'out_ware_name',
      render: (text) => (
        <Tooltip title={text}>
          <span>{text.substring(0, 50)}</span>
        </Tooltip>
      )
    },
    {
      title: '佣金',
      dataIndex: 'out_estimate_fee',
      render: (value) => <>{value / 100}</> 
    },
    {
      title: '金额',
      dataIndex: 'out_estimate_price',
      render: (value) => <>{value / 100}</> 
    },
    {
      title: '标题',
      dataIndex: 'content_title',
    },
    {
      title: '状态',
      render: (_, { status_name }) => (
        <>
          <Tag color={status_name === '已完成' ? 'success' : 'processing'}>
            {status_name}
          </Tag>
        </>
      )
    }
  ]
  return <Table loading={loading} columns={columns} dataSource={data} rowKey="id" />
}
